import { getLocale } from '@gamiphy/utils/locale';

declare global {
  interface Window {
    GAMIPHY_LOCALE?: string,
    GAMIPHY_CURRENCY_CODE?: string,
  }
}

export const getCurrencySymbol = (currency: string | undefined = window.GAMIPHY_CURRENCY_CODE): string => {
  const formatter = new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(0)
    .replace('0', '');
};

/**
 * Format price as a currency price string
 * @param price The cash value
 * @param currency Custom cash currency
 */
export const formatCash = (price = 0, currency: string | undefined = window.GAMIPHY_CURRENCY_CODE): string => {
  try {
    const formatter = new Intl.NumberFormat(getLocale(), {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(price);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return `${currency?.toUpperCase() ?? ''} 0`;
};

export const formatPoints = (points: number): string => {
  try {
    return new Intl.NumberFormat().format(points);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return '0';
};
